import { TranscriptBlock } from '@/api/types/backend-dto-types';

export interface LiveTranscriptBlock
  extends Omit<TranscriptBlock, 'internalSpeaker' | 'correction' | 'transcript' | 'session'> {
  isPartial: boolean;
  audioReady?: boolean;
  internalSpeaker?: {
    id: string;
    internalName: string;
    speakerId: string | null;
    speaker?: {
      id: string;
      name: string;
      color?: string;
    } | null;
  } | null;
  correction?: {
    id: string;
    confidence: number;
    originalContent: string;
    status?: 'pending' | 'accepted' | 'rejected';
    correctedSegments: Array<{
      content: string;
      speakerId: string;
      startTime: number;
      endTime: number;
    }>;
    analysis: {
      primaryIssue: string;
      improvementSource: 'fast' | 'real-time' | 'hybrid';
      speakerChanges: number;
      reasoning: string;
    };
  } | null;
}

// Type guard to check if a block is a live block
export function isLiveBlock(block: TranscriptBlock | LiveTranscriptBlock): block is LiveTranscriptBlock {
  return 'isPartial' in block;
}
